import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, isRef as _isRef, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-da88c5ae"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "title" }
const _hoisted_2 = { class: "margin_b_m" }
const _hoisted_3 = { class: "text_bold" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))

import DialogBase from '@/components/molecules/DialogBase'
import { computed, withDefaults, nextTick } from 'vue'
import { useRouter } from 'vue-router'

type PropsType = {
  modelValue?: boolean
}


export default /*#__PURE__*/_defineComponent({
  __name: 'NotRecommendedDialog',
  props: {
    modelValue: { type: Boolean, default: false }
  },
  emits: ["update:modelValue"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'update:modelValue', value: boolean): void
}), expose: any, slots: any, attrs: any }) {

const props = __props as { modelValue: boolean };

const router = useRouter()




const internalValue = computed({
  get: () => props.modelValue,
  set: (newVal) => {
    emit('update:modelValue', newVal)
  },
})

const close = () => {
  internalValue.value = false
}

const showHelp = () => {
  internalValue.value = false
  nextTick(() => {
    router.push({ name: 'help' })
  })
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(DialogBase), {
    modelValue: _unref(internalValue),
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(internalValue) ? (internalValue).value = $event : null)),
    useCancelBtn: false,
    onApprove: close
  }, {
    title: _withCtx(() => [
      _createElementVNode("h1", _hoisted_1, _toDisplayString(_ctx.$t('not_recommended_dialog.please_confirm')), 1)
    ]),
    body: _withCtx(() => [
      _createElementVNode("div", null, [
        _createElementVNode("p", _hoisted_2, [
          _createTextVNode(_toDisplayString(_ctx.$t('not_recommended_dialog.your_browser')) + " ", 1),
          _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.$t('not_recommended_dialog.not_supported')), 1),
          _createTextVNode(" " + _toDisplayString(_ctx.$t('not_recommended_dialog.it_becomes')), 1)
        ]),
        _createElementVNode("p", null, [
          _createTextVNode(_toDisplayString(_ctx.$t('not_recommended_dialog.recommended_browser')) + " ", 1),
          _createElementVNode("span", {
            onClick: showHelp,
            class: "text_link"
          }, _toDisplayString(_ctx.$t('not_recommended_dialog.support_environment')), 1),
          _createTextVNode(" " + _toDisplayString(_ctx.$t('not_recommended_dialog.so')), 1),
          _hoisted_4,
          _createTextVNode(" " + _toDisplayString(_ctx.$t('not_recommended_dialog.please_confirm')), 1)
        ])
      ])
    ]),
    _: 1
  }, 8, ["modelValue"]))
}
}

})